import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

require('./bringoz-pagination.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-pagination',
  templateUrl: './bringoz-pagination.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozPaginationComponent implements OnInit, OnChanges {

  @Input() totalElements: number;
  @Input() pageIndex: number = 0;
  @Input() maxNumbersToDisplay: number = 2;
  @Input() elementsPerPage: number = 1; // limit
  @Output() pageIndexChangeEvent = new EventEmitter<number>();

  constructor(@Inject('$timeout') private $timeout) {
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
  }

  onPageIndexChange(index) {
    this.pageIndexChangeEvent.emit(index);
    this.$timeout(0).then(() => {
    });
  }
}
